import type React from "react";
import ObjectPropertyItem from "../../../../../components/Headers/ObjectPropertyItem";
import { Heading } from "../../../../../components/Theme/heading";
import DisplayIfUserType from "../../../../../components/utils/DisplayIfUserType/DisplayIfUserType";
import { getAmrDisplayData } from "./amrMetadataConfig";

export default function AmrMetadataDisplay(props: {
  amr_metadata: unknown;
}): React.ReactElement | null {
  const displayData = getAmrDisplayData(props.amr_metadata);
  if (!displayData) return null;

  return (
    <DisplayIfUserType userTypes="admin">
      <div className="mb-4">
        <Heading level={3}>Data Collection System</Heading>
        <div className="flex flex-wrap">
          <ObjectPropertyItem title="System Type">
            {displayData.typeLabel}
          </ObjectPropertyItem>
          {displayData.fields.map((field) => (
            <ObjectPropertyItem key={field.label} title={field.label}>
              {field.value}
            </ObjectPropertyItem>
          ))}
        </div>
      </div>
    </DisplayIfUserType>
  );
}
